import { useEffect, useState } from 'react'
import { TextTypes } from '../components/typography/text/index'
import { useWindowSize } from 'hooks'

export interface PortfolioFontSizes {
  labelSize: TextTypes
  valueSize: TextTypes
  buttonSize: TextTypes
  titleSize: TextTypes
}
/**
 * Returns correct sizes for the portfolio screen text components
 * @returns
 */
export const useTextTypes = (): PortfolioFontSizes => {
  const { isMobile, isDesktop } = useWindowSize()
  const [labelSize, setLabelSize] = useState<TextTypes>('small')
  const [valueSize, setValueSize] = useState<TextTypes>('p')
  const [buttonSize, setButtonSize] = useState<TextTypes>('p')
  const [titleSize, setTitleSize] = useState<TextTypes>('p')
  /**
   * These sizes are derived from figma
   */
  useEffect(() => {
    if (isMobile) {
      setLabelSize('small')
      setValueSize('p')
      setButtonSize('p')
      setTitleSize('p')
    }
    if (isDesktop) {
      setButtonSize('p')
      setLabelSize('p')
      setValueSize('nav')
    }
  }, [isMobile, isDesktop])

  return {
    labelSize,
    valueSize,
    buttonSize,
    titleSize,
  }
}
export default useTextTypes
